import React from 'react';

export default function RefreshIcon(props) {
  return (
    <svg width={49} height={39} viewBox="0 0 49 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8_6963)">
        <path d="M5.50977 19.4499C5.50977 9.07992 13.9198 0.669922 24.2798 0.669922C32.5798 0.669922 39.6298 6.05992 42.0998 13.5299" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M43.0599 19.45C43.0599 29.82 34.6599 38.22 24.2899 38.22C15.9299 38.22 8.84992 32.7599 6.41992 25.2099" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.50992 19.4499L0.669922 13.9299" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.50977 19.4499L11.0298 14.6099" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M43.0601 19.45L47.9001 24.9699" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M37.54 24.29L43.06 19.45" stroke="#00F4A1" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_8_6963">
          <rect width="48.57" height="38.89" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
